<div class="otp-page">
  <div class="otp-form">
    <div class="header">
      Enter the one time password<br />
      sent to ***{{getLastDigits(phone)}}
    </div>
    <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="config"></ng-otp-input>
  </div>
</div>